import DapDSPager from './pager.component'

export * from './pager.component'
export default DapDSPager

DapDSPager.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-pager': DapDSPager
  }
}
